import { List, Map } from 'immutable';
import BaseList from 'records/BaseList';
import Design, { Designs } from 'records/Design';

import {
  DESIGNS_ASYNC_ACTION_START,
  DESIGNS_ASYNC_ACTION_SUCCESS,
  DESIGNS_ASYNC_ACTION_ERROR,
  DESIGNS_UPDATE_FILTERS,
  DESIGNS_DRAGGABLE_UPDATE,
  DESIGNS_RESET_STATE,
  DESIGNS_SET_DUPDESIGNID,
  DESIGNS_ADD_DESIGN,
} from 'actions/designs';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  filters: new Map({
    selectedDesignType: null,
  }),
  data: new List(),
});

const actionsMap = {
  [DESIGNS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [DESIGNS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [DESIGNS_ASYNC_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: Designs(action.data),
    });
  },
  [DESIGNS_UPDATE_FILTERS]: (state, action) => {
    const newState = state.setIn(['filters', action.key], action.value);
    return newState;
  },
  [DESIGNS_DRAGGABLE_UPDATE]: (state, action) => {
    let newDesignsData = Design.updateDesignOrdinalsFromIndex(action.data);
    newDesignsData = Design.sortDesignsByOrdinal(newDesignsData);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newDesignsData,
    });
  },
  [DESIGNS_RESET_STATE]: () => {
    return initialState;
  },
  [DESIGNS_SET_DUPDESIGNID]: (state, action) => {
    return state.merge({
      sortKey: action.data,
    });
  },
  [DESIGNS_ADD_DESIGN]: (state, action) => {
    const updated = state.data.unshift(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: updated,
    });
  },
};

export default function designs(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
